import cn from "classnames";
import React from "react";
import { Dot } from "../Dot";
// @ts-ignore
import styles from "./Pagination.module.scss";

interface PaginationProps {
  totalSlides: number;
  activeIndex: number;
  sliderRef: React.MutableRefObject<any>;
  dot?: React.FC<{ onClick: () => void; children: React.ReactNode }>;
}

export const Pagination: React.FC<PaginationProps> = ({ totalSlides, activeIndex, sliderRef, dot = Dot }) => {
  const PaginationItem = dot;

  return (
    <ul className={cn(styles.pagination, { [styles.hideMobilePagination]: totalSlides > 10 })}>
      {Array.from({ length: totalSlides }, (_, i) => (
        <li key={i}>
          <PaginationItem
            onClick={() => sliderRef?.current?.slickGoTo(i)}
            className={cn(styles.dot, {
              [styles.dotActive]: activeIndex === i,
            })}
          >
            {i + 1}
          </PaginationItem>
        </li>
      ))}
    </ul>
  );
};
